import { OrderBuilderActions, RESET_BUILDER } from '../../../../actions/order-builder.actions';
import {
  RmsOrderActionTypes,
  RmsOrderActions,
} from '@ordersnproducts/modules/order-builder/modules/rms-summary/actions/open-platform/order.actions';
import { OrderULResponse } from '@cemex-core/cmx-api';

export interface RmsOrderState {
  loading: boolean;
  orderResponse: OrderULResponse;
}

export const initialState: RmsOrderState = {
  loading: false,
  orderResponse: null,
};

export function orderReducer(state = initialState, action: RmsOrderActions | OrderBuilderActions): RmsOrderState {
  switch (action.type) {
    case RmsOrderActionTypes.REQUEST: {
      return {
        ...state,
        ...initialState,
        loading: true,
      } as RmsOrderState;
    }
    case RmsOrderActionTypes.REQUEST_COMPLETE: {
      return {
        ...state,
        loading: false,
        orderResponse: action.payload,
      } as RmsOrderState;
    }
    case RESET_BUILDER:
    case RmsOrderActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
